import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ContractorCard from './ContractorCard';
import { getFeaturedContractors } from '../api/contractorProfile';
import { ContractorProfile } from '../types/contractor';

const PLACEHOLDER_IMAGE = 'https://via.placeholder.com/400x200?text=No+Image';

function toCardProps(c: ContractorProfile) {
  return {
    contractorId: c.id,
    name: c.companyName || 'Unnamed Contractor',
    rating: c.averageRating ?? 0,
    reviews: c.reviewCount ?? 0,
    experience: `${c.yearsOfExperience} yrs exp.`,
    category: c.categories?.[0] ?? '',
    price: '—',
    priceUnit: '',
    image: c.profilePictureUrl || PLACEHOLDER_IMAGE,
    isVerified: c.isVerified ?? false,
  };
}

const FeaturedContractors: React.FC = () => {
  const [contractors, setContractors] = useState<ContractorProfile[]>([]);

  useEffect(() => {
    getFeaturedContractors()
      .then(setContractors)
      .catch((err) => console.error('Failed to load featured contractors:', err));
  }, []);

  if (contractors.length === 0) return null;

  return (
    <section className="bg-surface-container-low py-20 px-container-margin">
      <div className="max-w-7xl mx-auto">

        {/* Mobile */}
        <div className="md:hidden space-y-stack-lg">
          <div className="flex justify-between items-end">
            <h2 className="font-headline-sm text-headline-sm-mobile text-primary">Featured Contractors</h2>
            <Link to="/contractors" className="text-secondary font-label-bold">View All</Link>
          </div>
          {contractors.slice(0, 3).map((c) => (
            <ContractorCard key={c.id} {...toCardProps(c)} isMobile={true} />
          ))}
        </div>

        {/* Desktop */}
        <div className="hidden md:block">
          <div className="flex justify-between items-end mb-10">
            <div>
              <h2 className="font-headline-md text-headline-md text-primary mb-2">Featured Professionals</h2>
              <p className="font-body-md text-body-md text-on-surface-variant">Top-rated contractors ready to start your next project.</p>
            </div>
            <Link to="/contractors" className="text-secondary font-label-bold text-label-bold flex items-center gap-1 hover:underline">
              View All Contractors
              <span className="material-symbols-outlined text-sm" data-icon="arrow_forward">arrow_forward</span>
            </Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {contractors.slice(0, 3).map((c) => (
              <ContractorCard key={c.id} {...toCardProps(c)} isDesktop={true} />
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default FeaturedContractors;
